import React, { useState, useContext } from 'react';
//import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import './Contact.css'; // Ensure you have a CSS file for styling
import { FaWhatsapp, FaMailBulk, FaLinkedin, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { LanguageContext } from './LanguageContext'; // Import LanguageContext

const containerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: 40.7128,
  lng: -74.0060
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const { language } = useContext(LanguageContext); // Use language context

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Email sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        alert('Failed to send email.');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Error sending email.');
    }
  };

  return (
    <section className="contact-section">
      <h1 className="contact-title">{language === 'en' ? 'Contact Us' : 'Bize Ulaşın'}</h1>
      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">{language === 'en' ? 'Name:' : 'İsim:'}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">{language === 'en' ? 'Email:' : 'E-posta:'}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">{language === 'en' ? 'Message:' : 'Mesaj:'}</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button className="btn btn-primary" type="submit">{language === 'en' ? 'Send' : 'Gönder'}</button>
        </form>
        <div className="get-in-touch">
          <h2>{language === 'en' ? 'Get in Touch' : 'İletişime Geçin'}</h2>
          <ul className="contact-links">
            <li>
              <FaWhatsapp />
              <a href="https://wa.me/905326330097" target="_blank" rel="noopener noreferrer">WhatsApp</a>
            </li>
            <li>
              <FaMailBulk />
              <a href="mailto:info@tacosoft.com.tr?subject=Hello&body=I%20am%20reaching%20out%20to%20you..." target="_blank" rel="noopener noreferrer">info@tacosoft.com.tr</a>
            </li>
            <li>
              <FaLinkedin />
              <a href="https://www.linkedin.com/company/tacosoft/posts/?feedView=all" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </li>
            <li>
              <FaPhone className="phone-icon" />
              <span>+90 (212) 266 67 86</span>
            </li>
            <li>
              <FaMapMarkerAlt />
              <a href="https://www.google.de/maps/place/Kadir+Has+%C3%9Cniversitesi+Silivri+Teknopark/@41.0518183,28.3789184,17z/data=!4m10!1m2!2m1!1sKadir+Has+%C3%9Cniversitesi+Silivri+Teknopark+Selimpa%C5%9Fa+Mah.+1010+Sk.+No:+10%2F1+A+Blok+Kat:+2+%C4%B0%C3%A7+Kap%C4%B1+No:+58+Silivri+%2F+%C4%B0stanbul!3m6!1s0x14b54182c27ce43b:0x85c0f74eef4bc226!8m2!3d41.0517842!4d28.3815408!15sCn9LYWRpciBIYXMgw5xuaXZlcnNpdGVzaSBTaWxpdnJpIFRla25vcGFyayBTZWxpbXBhxZ9hIE1haC4gMTAxMCBTay4gTm86IDEwLzEgQSBCbG9rIEthdDogMiDEsMOnIEthcMSxIE5vOiA1OCBTaWxpdnJpIC8gxLBzdGFuYnVsIgOIAQGSAQ90ZWNobm9sb2d5X3BhcmvgAQA!16s%2Fg%2F11vs3pz83r?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                {language === 'en' ? 'Kadir Has University Silivri Technopark Selimpaşa Mah. 1010 Sk. No: 10/1 A Blok Kat: 2 İç Kapı No: 58 Silivri / İstanbul' : 'Kadir Has Üniversitesi Silivri Teknopark Selimpaşa Mah. 1010 Sk. No: 10/1 A Blok Kat: 2 İç Kapı No: 58 Silivri / İstanbul'}
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* <div className="map-container">
         <LoadScript googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY">
           <GoogleMap
             mapContainerStyle={containerStyle}
             center={center}
             zoom={14}
           >
             <Marker position={center} />
           </GoogleMap>
         </LoadScript>
       </div>*/}
    </section>
  );
};

export default ContactForm;
